"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useHideRating = require("./useHideRating");
Object.keys(_useHideRating).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useHideRating[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useHideRating[key];
    }
  });
});
